/*
  fav-terms.js — Favoritten.dk

  Spaerrer vejen til kassen indtil handelsbetingelserne er accepteret.

  Delegeret fra document, fordi kurv-drawer'en og kurv-sektionen begge
  gen-renderes via Shopifys section rendering API. Bindes handlere direkte
  paa knapperne, forsvinder de ved foerste opdatering af kurven.

  Vi fanger BAADE click og submit: kurv-siden bruger et <a href="/checkout">,
  drawer'en en <button name="checkout" form="CartDrawer-Form">.
*/
(function () {
  'use strict';

  var CHECKOUT = '[name="checkout"], .fav-checkout-btn, .cart__checkout-button';

  /* Find den afkrydsning der hoerer til den klikkede knap.

     Der maa IKKE vaere et dokument-bredt fallback her. Drawer'en ligger i
     DOM'en paa hver eneste side, og produktsidens "Koeb nu" bruger ogsaa
     name="checkout" — et fallback ville spaerre den mod et flueben inde i
     en lukket drawer, som brugeren ikke kan se. Kun knapper der ligger i
     samme kurv-beholder som en afkrydsning bliver gated. */
  function findTerms(el) {
    var scope = el.closest('cart-drawer, .fav-cart-summary');
    return scope ? scope.querySelector('[data-fav-terms-box]') : null;
  }

  function block(box) {
    var wrap = box.closest('[data-fav-terms]');
    var err = wrap && wrap.querySelector('[data-fav-terms-error]');
    if (err) err.hidden = false;
    if (wrap) {
      wrap.classList.add('fav-terms--invalid');
      wrap.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    box.focus();

    /* Maaler hvor tit spaerren rammer. Vi tilfoejede den i dag, og hvis den
       koster konverteringer skal vi opdage det paa dage, ikke maaneder.
       Kun FOERSTE blokering pr. sidevisning taelles — ellers giver et par
       ekstra klik paa knappen et falsk hoejt tal. */
    if (!block.sendt && window.favTrack) {
      block.sendt = true;
      window.favTrack('Betingelser blokeret', {
        sted: box.closest('cart-drawer') ? 'drawer' : 'kurvside',
      });
    }
  }

  function guard(event) {
    var btn = event.target.closest(CHECKOUT);
    if (!btn) return;

    var box = findTerms(btn);
    if (!box || box.checked) return;

    event.preventDefault();
    event.stopPropagation();
    block(box);
  }

  /* capture: true — vi skal naa foer temaets egne handlere og foer
     formularens egen submit, ellers er turen til checkout allerede sat i gang. */
  document.addEventListener('click', guard, true);
  /* Drawer'ens knap ligger uden for <form> og hoerer til via form="...",
     saa vi kan ikke lede efter knappen inde i formularen. Vi tager
     udgangspunkt i formularen selv og spoerger om DEN staar i en
     kurv-beholder med et flueben. */
  document.addEventListener('submit', function (event) {
    var box = findTerms(event.target);
    if (!box || box.checked) return;
    event.preventDefault();
    block(box);
  }, true);

  /* Ryd fejlen saa snart brugeren saetter fluebenet. */
  document.addEventListener('change', function (event) {
    var box = event.target.closest('[data-fav-terms-box]');
    if (!box || !box.checked) return;
    var wrap = box.closest('[data-fav-terms]');
    var err = wrap && wrap.querySelector('[data-fav-terms-error]');
    if (err) err.hidden = true;
    if (wrap) wrap.classList.remove('fav-terms--invalid');
  });
})();
